var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticStyle:{"display":"none"},attrs:{"id":"upload_id","type":"file","multiple":"multiple"},on:{"change":_vm.uploadFile}})}
var staticRenderFns = []

export { render, staticRenderFns }